// 由 src/views/smart-workbench/index.vue 的 methods 拆分而来，请勿在此文件之外重复定义同名方法。
// 分析执行流程：PVMC 分析、四象限计划、指标创建/推荐/缺失分析、智能流式流程与 DOM 同步等
// 方法体与原文件逐字节一致（仅调整文件归属）。
import { getSharedWsUrl } from './workspaceConstants'

export default {
  methods: {
    startPVMCMAnalysis() {
      this.appendLocalMessage('user', 'PVMC模型分析毛利波动原因')
      setTimeout(() => {
        const thinkingSteps = [
          '首先，我需要获取最近5个季度的毛利率数据，建立分析基准...',
          '数据加载完成，发现今年毛利率17.1%，去年同期18.7%，同比下降1.6个百分点',
          '现在开始应用PVMC模型进行四维拆解分析...',
          '价格维度分析（P）：对比销售单价变化，发现平均售价同比下降3.2%，主要受行业价格战影响...',
          '价格影响量化完成：P维度贡献 -1.8%，核心原因是竞品持续降价促销，被动跟随调价',
          '销量维度分析（V）：正在调取分区域、分客户销售数据...',
          '销量影响量化完成：V维度贡献 -5.2%，华南区域3家大客户流失是主因，订单量下降6.2%',
          '产品结构分析（M）：正在计算高毛利产品占比变化与结构性偏移...',
          '结构影响量化完成：M维度贡献 -1.4%，高毛利产品占比从35%降至22%，低毛利特价品大幅增长',
          '成本维度分析（C）：正在从采购系统获取原材料价格变动数据...',
          '成本影响量化完成：C维度贡献 +3.2%（改善项），但钢材上涨8.5%、电子元器件涨幅13-28%，改善效果被抵消',
          '四维汇总：P(-1.8%) + V(-5.2%) + M(-1.4%) + C(+3.2%) = 净影响 -1.6%，与实际数据一致',
          '交叉验证通过：PVMC拆解结果与实际下滑幅度吻合，模型分析可信',
          '正在汇总核心发现与根因定位，生成详细分析报告...'
        ]
        const thinkingId = 'thinking-pvmc-' + Date.now()
        this.appendLocalMessage(
          'assistant',
          this.renderCeoThinkingCard(
            thinkingId,
            thinkingSteps[0],
            'PVMC模型深度拆解',
            '正在对毛利率下降原因进行四维拆解分析：价格(P) × 销量(V) × 产品结构(M) × 成本(C)...',
            thinkingSteps.length
          ),
          true
        )
        let stepIndex = 1
        const thinkingInterval = setInterval(() => {
          if (stepIndex < thinkingSteps.length) {
            this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIndex)
            stepIndex++
          } else {
            clearInterval(thinkingInterval)
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderPVMCAnalysisStreamCard()
            }, 800)
          }
        }, 2000)
        this.smartAnalysisTimers.push(thinkingInterval)
      }, 600)
    },
    renderPVMCAnalysisStreamCard() {
      const replyId = 'pvmc-stream-' + Date.now()
      const summaryId = `pvmc-summary-${replyId}`

      const summaryText =
        '基于PVMC模型分析，已完成对毛利下降原因的深度拆解。' +
        '分析结果显示，BOM成本上升与采购降本兑现不足为核心因素，均为供应链端成本因素。'

      const pvmcCellVals = ['-1.02pct', '-0.63pct', '+8.2%/+5.4%/+4.1%', '+812万']
      const pvmcCellDescs = [
        'BOM成本上升（62%）· -412万',
        '采购降本兑现不足（38%）· -256万',
        '原材料价格涨幅 · PCB/铜/锡',
        '四项关差方案 · 目标18.0%+'
      ]
      const pvmcCellSubs = [
        'PCB+8.2%/铜+5.4%/锡+4.1%',
        '年度目标820万仅兑现60%',
        '主力产品A-1000/B-2000承压',
        '12周追回·毛利率恢复'
      ]
      const pvmcSummaryBarText =
        '总影响分析：按PVMC模型，BOM成本上升与采购降本兑现不足是毛利率下降的核心驱动因素，合计拉低毛利率-1.65pct，影响毛利额-668万。当前毛利率17.1%，目标恢复至18.0%以上。'
      const pvmcFooterText =
        '综合分析显示，BOM成本上升与采购降本兑现不足是毛利下降的核心驱动因素，合计贡献了超过60%的毛利下降影响（PVMC模型）。建议优先审阅CEO专项报告，推动PCB替代料验证锁价、铜锡季度锁价谈判、直降谈判加速与返利催收三项关差动作落地。当前毛利率17.1%，目标恢复至18.0%以上，预计四项关差方案可在12周内追回812万毛利额。'

      const rootTitles = [
        { title: 'BOM成本上升（贡献 -1.02pct，占62%）', color: '#dc2626' },
        { title: '采购降本兑现不足（贡献 -0.63pct，占38%）', color: '#d97706' },
        { title: '产品结构与价格竞争（贡献 -0.35pct）', color: '#4A5FF3' }
      ]

      const rootTexts = [
        'PCB+8.2%、铜+5.4%、锡+4.1%持续推高单位成本，主力产品A-1000/B-2000承压最重；影响毛利额-412万。',
        '年度降本目标820万仅兑现60%（缺口328万），影响毛利额-256万。PCB替代料验证周期拉长、铜锡锁价谈判尚未完成是关键瓶颈。',
        '低毛利储能订单占比持续上升，叠加行业价格竞争，进一步压缩毛利空间。'
      ]

      const rootStyles = [
        { bg: '#fef2f2', bd: '#fecaca', dot: '#dc2626' },
        { bg: '#fff', bd: '#e8ecf0', dot: '#d97706' },
        { bg: '#fff', bd: '#e8ecf0', dot: '#4A5FF3' }
      ]

      const rootCauseItemsHtml = rootTitles
        .map(
          (item, idx) => `
        <div id="pvmc-root-${idx}-${replyId}" style="display:flex;align-items:flex-start;gap:8px;padding:10px 12px;border-radius:10px;background:${rootStyles[idx].bg};border:1px solid ${rootStyles[idx].bd};opacity:0;transform:translateX(-6px);transition:all .32s ease;">
          <span style="margin-top:5px;width:6px;height:6px;border-radius:50%;background:${rootStyles[idx].dot};flex-shrink:0;"></span>
          <span style="font-size:12px;color:#4b5563;line-height:1.7;">
            <b style="color:${item.color};">${item.title}</b>
            <span id="pvmc-root-text-${idx}-${replyId}"></span>
          </span>
        </div>
      `
        )
        .join('')

      const cardHtml = `
        <div id="pvmc-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

          <!-- 区块1：标题头 -->
          <div id="pvmc-section-0-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;gap:10px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#3B82F6,#60A5FA);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">CF</div>
              <div style="flex:1;">
                <div style="font-size:12px;font-weight:600;color:#1f2937;">CFO数字人</div>
                <div style="font-size:10px;color:#8c9bab;">PVMC模型分析</div>
              </div>
              <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#eef4ff;color:#4A5FF3;font-size:11px;font-weight:600;">模型诊断</span>
            </div>
            <div style="font-size:15px;font-weight:700;color:#1f2937;margin-top:10px;">毛利波动原因分析报告</div>
          </div>

          <!-- 区块2：总结（typewriter） -->
          <div id="pvmc-section-1-${replyId}" style="display:none;padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,rgba(74,95,243,0.06),rgba(14,165,233,0.04));border:1px solid rgba(74,95,243,0.14);opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div id="${summaryId}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;"></div>
          </div>

          <!-- 区块3：PVMC四维度卡片（逐条流式） -->
          <div id="pvmc-section-2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);">
              <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;">
                <div style="font-size:12px;font-weight:700;color:#1f2937;">PVMC四维度影响分析</div>
                <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#fef2f2;color:#dc2626;font-size:11px;font-weight:600;">成本归因</span>
              </div>
              <div id="pvmc-grid-${replyId}" style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
                <div id="pvmc-cell-0-${replyId}" style="padding:12px 10px;border-radius:10px;background:#fef2f2;border:1px solid #fecaca;box-shadow:0 1px 3px rgba(15,23,42,0.04);opacity:0;transform:translateY(6px);transition:all .28s ease;">
                  <div id="pvmc-cell-val-0-${replyId}" style="font-size:20px;font-weight:800;color:#dc2626;line-height:1;min-height:28px;"></div>
                  <div id="pvmc-cell-desc-0-${replyId}" style="margin-top:6px;font-size:12px;color:#8c9bab;min-height:16px;"></div>
                  <div id="pvmc-cell-sub-0-${replyId}" style="font-size:11px;color:#aaa;margin-top:2px;min-height:15px;"></div>
                </div>
                <div id="pvmc-cell-1-${replyId}" style="padding:12px 10px;border-radius:10px;background:#fff7ed;border:1px solid #fed7aa;box-shadow:0 1px 3px rgba(15,23,42,0.04);opacity:0;transform:translateY(6px);transition:all .28s ease;">
                  <div id="pvmc-cell-val-1-${replyId}" style="font-size:20px;font-weight:800;color:#d97706;line-height:1;min-height:28px;"></div>
                  <div id="pvmc-cell-desc-1-${replyId}" style="margin-top:6px;font-size:12px;color:#8c9bab;min-height:16px;"></div>
                  <div id="pvmc-cell-sub-1-${replyId}" style="font-size:11px;color:#aaa;margin-top:2px;min-height:15px;"></div>
                </div>
                <div id="pvmc-cell-2-${replyId}" style="padding:12px 10px;border-radius:10px;background:#eff6ff;border:1px solid #bfdbfe;box-shadow:0 1px 3px rgba(15,23,42,0.04);opacity:0;transform:translateY(6px);transition:all .28s ease;">
                  <div id="pvmc-cell-val-2-${replyId}" style="font-size:20px;font-weight:800;color:#4A5FF3;line-height:1;min-height:28px;"></div>
                  <div id="pvmc-cell-desc-2-${replyId}" style="margin-top:6px;font-size:12px;color:#8c9bab;min-height:16px;"></div>
                  <div id="pvmc-cell-sub-2-${replyId}" style="font-size:11px;color:#aaa;margin-top:2px;min-height:15px;"></div>
                </div>
                <div id="pvmc-cell-3-${replyId}" style="padding:12px 10px;border-radius:10px;background:#f0fdf4;border:1px solid #bbf7d0;box-shadow:0 1px 3px rgba(15,23,42,0.04);opacity:0;transform:translateY(6px);transition:all .28s ease;">
                  <div id="pvmc-cell-val-3-${replyId}" style="font-size:20px;font-weight:800;color:#16a34a;line-height:1;min-height:28px;"></div>
                  <div id="pvmc-cell-desc-3-${replyId}" style="margin-top:6px;font-size:12px;color:#8c9bab;min-height:16px;"></div>
                  <div id="pvmc-cell-sub-3-${replyId}" style="font-size:11px;color:#aaa;margin-top:2px;min-height:15px;"></div>
                </div>
              </div>
              <div id="pvmc-summary-bar-${replyId}" style="margin-top:10px;padding:10px 12px;border-radius:10px;background:#f0f5ff;border:1px solid rgba(74,95,243,0.18);opacity:0;transform:translateY(6px);transition:all .32s ease;">
                <div id="pvmc-summary-bar-text-${replyId}" style="font-size:12px;color:#5a6b7e;line-height:1.7;min-height:20px;"></div>
              </div>
            </div>
          </div>

          <!-- 区块4：根因分析（逐条渐显 + typewriter） -->
          <div id="pvmc-section-3-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.04),rgba(14,165,233,0.02));border:1px solid #e8ecf0;">
              <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;">
                <div style="font-size:12px;font-weight:700;color:#1f2937;">核心发现与根因分析</div>
                <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#fef2f2;border:1px solid rgba(229,75,61,0.18);font-size:11px;color:#e54b3d;font-weight:600;">毛利率预警</span>
              </div>
              <div id="pvmc-rootcause-${replyId}" style="display:flex;flex-direction:column;gap:6px;">
                ${rootCauseItemsHtml}
              </div>
            </div>
          </div>

          <!-- 区块5：分析总结 + 四象限按钮 -->
          <div id="pvmc-section-4-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="padding:14px;border-radius:12px;background:#f8f9fc;border:1px solid #e8ecf0;">
              <div id="pvmc-footer-text-${replyId}" style="font-size:12px;color:#5a6b7e;line-height:1.8;margin-bottom:12px;min-height:20px;"></div>
              <div id="pvmc-btn-${replyId}" style="display:none;">
                <div style="display:flex;justify-content:flex-start;">
                  <button type="button" onclick="if(window.generateFourQuadrantPlans){window.generateFourQuadrantPlans();}" style="padding:10px 22px;border-radius:12px;font-size:13px;font-weight:600;border:none;cursor:pointer;color:#fff;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);white-space:nowrap;box-shadow:0 2px 8px rgba(74,95,243,0.25);">四象限分析生成提升方案</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)

      // 串行渐显：通过回调链式触发
      setTimeout(() => this.revealSection(`pvmc-section-0-${replyId}`, ''), 120)
      setTimeout(() => {
        this.revealSection(`pvmc-section-1-${replyId}`, '')
        setTimeout(() => {
          this.typeWriterEffect(summaryId, summaryText, () => {
            // ── 总结打完 → PVMC四维卡片（逐个流式） ──
            this.revealSection(`pvmc-section-2-${replyId}`, '')
            let cellIdx = 0
            const showNextCell = () => {
              if (cellIdx >= 4) {
                // 四个单元格打完 → 总影响摘要
                setTimeout(() => {
                  const barEl = this._findVisibleEl(`pvmc-summary-bar-${replyId}`)
                  if (barEl) {
                    barEl.style.opacity = '1'
                    barEl.style.transform = 'translateY(0)'
                  }
                  setTimeout(() => {
                    this.typeWriterEffect(
                      `pvmc-summary-bar-text-${replyId}`,
                      pvmcSummaryBarText,
                      () => {
                        // ── 总摘要打完 → 根因分析（逐条流式） ──
                        setTimeout(() => {
                          this.revealSection(`pvmc-section-3-${replyId}`, '')
                          let rootIdx = 0
                          const showNextRoot = () => {
                            if (rootIdx >= 3) {
                              setTimeout(() => {
                                this.revealSection(`pvmc-section-4-${replyId}`, '')
                                setTimeout(() => {
                                  this.typeWriterEffect(
                                    `pvmc-footer-text-${replyId}`,
                                    pvmcFooterText,
                                    () => {
                                      const btnEl = this._findVisibleEl(
                                        `pvmc-btn-${replyId}`
                                      )
                                      if (btnEl) {
                                        btnEl.style.display = 'block'
                                        btnEl.style.opacity = '0'
                                        btnEl.style.transition = 'opacity 0.4s ease'
                                        setTimeout(() => {
                                          btnEl.style.opacity = '1'
                                        }, 50)
                                      }
                                    }
                                  )
                                }, 300)
                              }, 400)
                              return
                            }
                            setTimeout(() => {
                              const el = this._findVisibleEl(
                                `pvmc-root-${rootIdx}-${replyId}`
                              )
                              if (el) {
                                el.style.opacity = '1'
                                el.style.transform = 'translateX(0)'
                              }
                              setTimeout(() => {
                                this.typeWriterEffect(
                                  `pvmc-root-text-${rootIdx}-${replyId}`,
                                  rootTexts[rootIdx],
                                  () => {
                                    rootIdx++
                                    showNextRoot()
                                  }
                                )
                              }, 280)
                            }, 200)
                          }
                          showNextRoot()
                        }, 400)
                      }
                    )
                  }, 240)
                }, 200)
                return
              }
              // 显示当前单元格
              setTimeout(() => {
                const cellEl = this._findVisibleEl(`pvmc-cell-${cellIdx}-${replyId}`)
                if (cellEl) {
                  cellEl.style.opacity = '1'
                  cellEl.style.transform = 'translateY(0)'
                }
                // 先打数值，再打描述，再打副标题
                this.typeWriterEffect(
                  `pvmc-cell-val-${cellIdx}-${replyId}`,
                  pvmcCellVals[cellIdx],
                  () => {
                    setTimeout(() => {
                      this.typeWriterEffect(
                        `pvmc-cell-desc-${cellIdx}-${replyId}`,
                        pvmcCellDescs[cellIdx],
                        () => {
                          setTimeout(() => {
                            this.typeWriterEffect(
                              `pvmc-cell-sub-${cellIdx}-${replyId}`,
                              pvmcCellSubs[cellIdx],
                              () => {
                                cellIdx++
                                showNextCell()
                              }
                            )
                          }, 180)
                        }
                      )
                    }, 200)
                  }
                )
              }, 200)
            }
            showNextCell()
          })
        }, 240)
      }, 440)
    },
    showPVMCSummary() {
      this.appendLocalMessage('user', '什么是PVMC？')
      setTimeout(() => {
        const contentHtml = `
          <div style="margin-top:12px;">
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px;">
              <div style="padding:14px;border-radius:10px;background:#ffffff;border:1px solid #e8ecf0;">
                <div style="font-size:16px;font-weight:700;color:#004baa;margin-bottom:6px;">P</div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:6px;">Price（价格）</div>
                <div style="font-size:12px;color:#5a6b7e;line-height:1.6;">产品售价变化对毛利的影响，包括定价策略调整、折扣促销活动、市场价格竞争等因素</div>
              </div>
              <div style="padding:14px;border-radius:10px;background:#ffffff;border:1px solid #e8ecf0;">
                <div style="font-size:16px;font-weight:700;color:#004baa;margin-bottom:6px;">V</div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:6px;">Volume（销量）</div>
                <div style="font-size:12px;color:#5a6b7e;line-height:1.6;">销售数量变化对毛利的影响，包括客户需求变化、市场份额变动、渠道覆盖情况等</div>
              </div>
              <div style="padding:14px;border-radius:10px;background:#ffffff;border:1px solid #e8ecf0;">
                <div style="font-size:16px;font-weight:700;color:#004baa;margin-bottom:6px;">M</div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:6px;">Mix（产品结构）</div>
                <div style="font-size:12px;color:#5a6b7e;line-height:1.6;">不同毛利率产品占比变化，包括高毛利产品推广效果、产品组合优化等</div>
              </div>
              <div style="padding:14px;border-radius:10px;background:#ffffff;border:1px solid #e8ecf0;">
                <div style="font-size:16px;font-weight:700;color:#004baa;margin-bottom:6px;">C</div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:6px;">Cost（成本）</div>
                <div style="font-size:12px;color:#5a6b7e;line-height:1.6;">单位成本变化对毛利的影响，包括原材料采购成本、生产成本、运营成本等</div>
              </div>
            </div>
            <div style="padding:14px;border-radius:10px;background:#f5f7fa;border:1px solid #e8ecf0;">
              <div style="font-size:12px;color:#004baa;font-weight:600;margin-bottom:8px;">应用价值</div>
              <div style="font-size:12px;color:#5a6b7e;line-height:1.8;">通过PVMC模型，可以将毛利变化精准拆解为四个维度，量化每个维度的影响程度，从而定位利润下降的核心原因，为管理层提供数据驱动的决策支撑。该模型广泛应用于制造业、零售业等行业的经营分析中。</div>
            </div>
          </div>
        `
        const cardHtml = `
          <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px 16px 14px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
            <div style="min-width:0;width:100%;box-sizing:border-box;">
              <div style="display:flex;align-items:center;gap:8px;">
                <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10B981,#34D399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">P</div>
                <div>
                  <div style="font-size:12px;font-weight:600;color:#1f2937;">规划数字人</div>
                  <div style="font-size:10px;color:#8c9bab;">刚刚</div>
                </div>
              </div>
              <div style="font-size:15px;font-weight:700;color:#1f2937;margin-top:12px;">PVMC分析方法</div>
              <div style="margin-top:8px;font-size:13px;line-height:1.7;color:#5a6b7e;width:100%;">PVMC是一种系统化的毛利分析框架，用于深度拆解利润变化的驱动因素。</div>
              ${contentHtml}
              <div style="margin-top:12px;">
                <span style="font-size:11px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="window.triggerCeoFollowUp('pvmc-summary-followup')">追问</span>
              </div>
            </div>
          </div>
        `
        this.followUpRegistry = this.followUpRegistry || {}
        this.followUpRegistry['pvmc-summary-followup'] = {
          title: '追问PVMC分析方法',
          summary: '请举例说明如何将PVMC模型应用到实际业务中。',
          prompt: '请举例说明如何将PVMC模型应用到实际业务中。'
        }
        this.appendLocalMessage('assistant', cardHtml, true)
      }, 500)
    },
    generateFourQuadrantPlans() {
      this.appendLocalMessage('user', '四象限分析生成提升方案')
      setTimeout(() => {
        const thinkingSteps = [
          '正在整理 PVMC 四维分析结论，识别关键改善方向...',
          '确认首要改善方向：BOM成本持续上涨（PCB+8.2%/铜+5.4%/锡+4.1%），需通过价格传导机制应对',
          '次要改善方向：产品结构恶化，低毛利储能订单占比持续上升，需调整产品组合策略',
          '第三改善方向：材料成本仍有优化空间，需深挖供应链降本潜力',
          '第四改善方向：制造成本可通过精益生产进一步优化',
          '正在构建四象限分析模型，横轴=实施难度，纵轴=毛利提升效果...',
          '象限一（高效果+低难度）：调整产品价格，评估可提升 +1.2% 毛利率',
          '象限二（高效果+中难度）：产品结构优化，评估可提升 +0.8% 毛利率',
          '象限三（中效果+高难度）：材料降本，评估可提升 +0.6% 毛利率',
          '象限四（中效果+中高难度）：制造成本优化，评估可提升 +0.4% 毛利率',
          '交叉测算：四套方案叠加预计可提升 +3.0% 毛利率，覆盖率 17.1%→20.1%',
          '正在编制具体执行方案与预期效果...'
        ]
        const thinkingId = 'quadrant-thinking-' + Date.now()
        this.appendLocalMessage(
          'assistant',
          this.renderCeoThinkingCard(
            thinkingId,
            thinkingSteps[0],
            '四象限提升方案生成',
            '正在基于PVMC分析结论，从实施难度与提升效果两个维度制定四套毛利率提升方案...',
            thinkingSteps.length
          ),
          true
        )
        let stepIdx = 1
        const thinkTimer = setInterval(() => {
          if (stepIdx < thinkingSteps.length) {
            this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
            stepIdx++
          } else {
            clearInterval(thinkTimer)
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderFourQuadrantStreamCard()
            }, 600)
          }
        }, 2000)
        this.smartAnalysisTimers.push(thinkTimer)
      }, 400)
    },

    renderFourQuadrantStreamCard() {
      const replyId = 'quadrant-stream-' + Date.now()
      const summaryId = `quadrant-summary-${replyId}`

      const summaryText =
        '基于四象限分析，已生成4套可执行的毛利率提升方案。' +
        '面对BOM成本持续上涨（PCB+8.2%/铜+5.4%/锡+4.1%），建议优先从调整产品价格开始，通过价格传导机制应对成本压力。'

      const plans = [
        {
          icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
          title: '调整产品价格',
          subtitle: '推荐优先执行',
          items: [
            '主力产品A-1000/B-2000提价5-8%，向客户传导BOM成本上涨',
            '建立价格联动机制，按原材料指数自动调价',
            '跟踪调价执行进度，确保主力产品覆盖率≥80%'
          ],
          effect: '+1.2%',
          difficulty: '低',
          diffColor: '#4A5FF3'
        },
        {
          icon: 'M3 3h18v18H3V3zm0 6h18M9 21V9',
          title: '产品结构优化',
          subtitle: '协同推进',
          items: [
            '提升高毛利产品销售占比，目标从38%提升至45%',
            '优化产品组合，建立分级销售激励机制',
            '加强产品生命周期管理，减少低毛利产品库存'
          ],
          effect: '+0.8%',
          difficulty: '中',
          diffColor: '#d97706'
        },
        {
          icon:
            'M20 7h-9M14 17H5m11 0a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m9-9a2 2 0 0 1 2 2v3.5a2.5 2.5 0 0 1-2.5 2.5H14',
          title: '材料降本',
          subtitle: '供应链优化',
          items: [
            '与核心供应商签订锁价协议，锁定3个月价格',
            '开发2-3家备选供应商引入竞争机制',
            '推进国产替代计划，降低进口原材料依赖'
          ],
          effect: '+0.6%',
          difficulty: '高',
          diffColor: '#dc2626'
        },
        {
          icon: 'M12 3a9 9 0 1 0 9 9M12 7v5l3 2',
          title: '制造成本优化',
          subtitle: '精益生产',
          items: [
            '优化生产排程，提升产能利用率至75%+',
            '工艺改进降低废品率，从2.9%降至2.0%',
            '智能化生产提升效率，降低单位产品工时'
          ],
          effect: '+0.4%',
          difficulty: '中高',
          diffColor: '#d97706'
        }
      ]

      const planCardsHtml = plans
        .map(
          (plan, idx) => `
        <div id="quadrant-plan-${idx}-${replyId}" style="opacity:0;transform:translateY(10px);transition:all .32s ease;">
          <div style="padding:14px;border-radius:12px;background:#f8fafc;border:1px solid rgba(74,95,243,0.2);">
            <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
              <div style="width:36px;height:36px;border-radius:10px;background:#4A5FF3;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><path d="${plan.icon}"/></svg>
              </div>
              <div style="flex:1;min-width:0;">
                <div style="font-size:14px;font-weight:600;color:#1f2937;">${plan.title}</div>
                <div style="font-size:12px;color:#4A5FF3;font-weight:500;">${plan.subtitle}</div>
              </div>
            </div>
            <div id="quadrant-plan-text-${idx}-${replyId}" style="font-size:12px;color:#5a6b7e;line-height:1.6;min-height:18px;"></div>
            <div style="display:flex;align-items:center;justify-content:space-between;padding-top:8px;margin-top:8px;border-top:1px solid #e8ecf0;">
              <span style="font-size:12px;color:#8898aa;">预期提升: <span style="color:#4A5FF3;font-weight:600;">${plan.effect}</span></span>
              <span style="padding:4px 10px;border-radius:4px;background:rgba(74,95,243,0.08);font-size:12px;color:${plan.diffColor};font-weight:500;">难度：${plan.difficulty}</span>
            </div>
          </div>
        </div>
      `
        )
        .join('')

      const planTexts = plans.map((p) => p.items.join('；'))

      const cardHtml = `
        <div id="quadrant-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

          <div id="quadrant-section-0-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;gap:10px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">G</div>
              <div style="flex:1;">
                <div style="font-size:12px;font-weight:600;color:#1f2937;">本体治理智能体</div>
                <div style="font-size:10px;color:#8c9bab;">四象限分析</div>
              </div>
              <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#eef4ff;color:#4A5FF3;font-size:11px;font-weight:600;">提升方案</span>
            </div>
            <div style="font-size:15px;font-weight:700;color:#1f2937;margin-top:10px;">智能提升方案</div>
          </div>

          <div id="quadrant-section-1-${replyId}" style="display:none;padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,rgba(74,95,243,0.06),rgba(14,165,233,0.04));border:1px solid rgba(74,95,243,0.14);opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div id="${summaryId}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;"></div>
          </div>

          <div id="quadrant-section-2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
              ${planCardsHtml}
            </div>
          </div>

          <div id="quadrant-section-3-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;padding:10px 14px;border-radius:10px;background:#f8f9fc;border:1px solid #e8ecf0;">
              <button style="padding:10px 22px;border-radius:12px;font-size:13px;font-weight:600;border:none;cursor:pointer;color:#fff;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);white-space:nowrap;box-shadow:0 2px 8px rgba(74,95,243,0.25);transition:all 0.2s;" onclick="if(window.applyRecommendedIndicators){window.applyRecommendedIndicators();}">应用推荐</button>
            </div>
          </div>
        </div>
      `

      this.followUpRegistry = this.followUpRegistry || {}
      this.followUpRegistry['quadrant-followup'] = {
        title: '追问四象限分析方案',
        summary:
          '基于四象限分析生成的提升方案，请继续展开说明调整产品价格方案的具体实施步骤。',
        prompt:
          '基于四象限分析生成的提升方案，请继续展开说明调整产品价格方案的具体实施步骤。'
      }
      this.appendLocalMessage('assistant', cardHtml, true)

      // 串行：通过回调链式触发
      setTimeout(() => this.revealSection(`quadrant-section-0-${replyId}`, ''), 120)
      setTimeout(() => {
        this.revealSection(`quadrant-section-1-${replyId}`, '')
        setTimeout(() => {
          this.typeWriterEffect(summaryId, summaryText, () => {
            // 总结打完 → 方案卡片逐个
            this.revealSection(`quadrant-section-2-${replyId}`, '')
            let planIdx = 0
            const showNextPlan = () => {
              if (planIdx >= 4) {
                setTimeout(
                  () => this.revealSection(`quadrant-section-3-${replyId}`, ''),
                  300
                )
                setTimeout(
                  () => this.revealSection(`quadrant-section-4-${replyId}`, ''),
                  500
                )
                return
              }
              setTimeout(() => {
                const el = this._findVisibleEl(`quadrant-plan-${planIdx}-${replyId}`)
                if (el) {
                  el.style.opacity = '1'
                  el.style.transform = 'translateY(0)'
                }
                setTimeout(() => {
                  this.typeWriterEffect(
                    `quadrant-plan-text-${planIdx}-${replyId}`,
                    planTexts[planIdx],
                    () => {
                      planIdx++
                      showNextPlan()
                    }
                  )
                }, 240)
              }, 200)
            }
            showNextPlan()
          })
        }, 240)
      }, 440)
    },
    applyPlanA() {
      this.appendLocalMessage('user', '应用推荐方案')
      setTimeout(() => {
        const progressId = 'indicator-progress-card-' + Date.now()
        const progressHtml = `
          <div id="${progressId}" style="padding:14px;border-radius:12px;background:#fff;border:1px solid rgba(74,95,243,0.1);box-shadow:0 4px 16px rgba(0,0,0,0.04);">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">
              <div style="width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);display:flex;align-items:center;justify-content:center;">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
              </div>
              <span style="font-size:12px;color:#4A5FF3;font-weight:500;">深度思考中</span>
            </div>
            <div style="font-size:12px;color:#5a6b7e;margin-bottom:10px;" id="progress-text-${progressId}">正在生成基于【调整产品价格】方案的指标组合... (0%)</div>
            <div style="height:4px;background:#e8ecf0;border-radius:2px;overflow:hidden;">
              <div id="progress-bar-${progressId}" style="height:100%;width:0%;background:linear-gradient(90deg,#4A5FF3,#6B7FFF);transition:width 0.3s ease;"></div>
            </div>
          </div>
        `
        this.appendLocalMessage('assistant', progressHtml, true)
        let progress = 0
        const progressInterval = setInterval(() => {
          progress += Math.random() * 15
          if (progress >= 100) {
            progress = 100
            clearInterval(progressInterval)
            const titleEl = document.querySelector('#' + progressId + ' span')
            const progressText = this._findVisibleEl('progress-text-' + progressId)
            const progressBar = this._findVisibleEl('progress-bar-' + progressId)
            if (titleEl) titleEl.innerHTML = '思考完成'
            if (progressText) {
              progressText.innerHTML =
                '已经生成基于【调整产品价格】方案的指标组合... (100%)'
            }

            if (progressBar) progressBar.parentElement.style.display = 'none'
          }
          const progressText = this._findVisibleEl('progress-text-' + progressId)
          const progressBar = this._findVisibleEl('progress-bar-' + progressId)
          if (progressText) {
            progressText.innerHTML =
              '正在生成基于【调整产品价格】方案的指标组合... (' +
              Math.round(progress) +
              '%)'
          }
          if (progressBar) progressBar.style.width = progress + '%'
        }, 150)
        this.smartAnalysisTimers.push(progressInterval)
        setTimeout(() => {
          clearInterval(progressInterval)
          this.removeThinkingCard(progressId)
          const replyId = 'apply-a-' + Date.now()
          const descTextId = `apply-a-desc-${replyId}`
          const valGrossCurrentId = `apply-a-gross-cur-${replyId}`
          const valGrossTargetId = `apply-a-gross-tgt-${replyId}`
          const valUnitCurrentId = `apply-a-unit-cur-${replyId}`
          const valUnitTargetId = `apply-a-unit-tgt-${replyId}`
          const descNew1Id = `apply-a-desc-new1-${replyId}`
          const descNew2Id = `apply-a-desc-new2-${replyId}`
          const introText =
            '基于【调整产品价格】方案，已生成关键指标组合，建议优先应用核心指标。面对BOM成本上升，通过产品调价传导成本压力是恢复毛利率的核心手段，建议重点追踪产品调价覆盖率和成本传导率。'
          const cardHtml = `
            <div id="apply-a-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
              <div style="padding:16px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
                <div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;">
                  <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">G</div>
                  <div>
                    <div style="font-size:12px;font-weight:600;color:#1f2937;">本体治理智能体</div>
                    <div style="font-size:10px;color:#8c9bab;">刚刚</div>
                  </div>
                </div>
                <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">提升毛利率的组合指标</div>
                <div id="${descTextId}" style="font-size:12px;color:#5a6b7e;line-height:1.7;margin-bottom:14px;min-height:22px;"></div>
                <div id="apply-a-section-1-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
                  <div style="font-size:13px;font-weight:600;color:#4A5FF3;margin-bottom:12px;">现有指标</div>
                  <div style="display:flex;flex-direction:column;gap:10px;margin-bottom:18px;">
                    <div id="apply-a-gross-${replyId}" style="display:none;">
                      <div style="display:flex;align-items:center;gap:12px;padding:14px;border-radius:10px;background:#fff;border:1px solid #e8ecf0;">
                        <div style="flex:1;">
                          <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                            <span style="font-size:13px;font-weight:600;color:#1f2937;">毛利率</span>
                            <span style="padding:3px 8px;border-radius:4px;background:rgba(74,95,243,0.08);font-size:12px;color:#4A5FF3;">核心指标</span>
                          </div>
                          <div style="display:flex;align-items:center;gap:10px;">
                            <span style="font-size:12px;color:#8898aa;">当前: <span id="${valGrossCurrentId}" style="color:#4A5FF3;font-weight:600;"></span></span>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8898aa" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                            <span style="font-size:12px;color:#8898aa;">目标: <span id="${valGrossTargetId}" style="color:#4A5FF3;font-weight:600;"></span></span>
                          </div>
                          <div style="font-size:12px;color:#6b7280;margin-top:6px;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8898aa" stroke-width="2" style="margin-right:4px;vertical-align:middle;"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-5 3.6-9 8-9s8 4 8 9"/></svg>负责人：销售部 李明</div>
                        </div>
                        <span style="font-size:12px;color:#4A5FF3;text-decoration:underline;cursor:pointer;font-weight:500;" onclick="if(window.applyIndicator){window.applyIndicator('毛利率');}">应用</span>
                      </div>
                    </div>
                    <div id="apply-a-unit-${replyId}" style="display:none;">
                      <div style="display:flex;align-items:center;gap:12px;padding:14px;border-radius:10px;background:#fff;border:1px solid #e8ecf0;">
                        <div style="flex:1;">
                          <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                            <span style="font-size:13px;font-weight:600;color:#1f2937;">平均销售单价（ASP）</span>
                            <span style="padding:3px 8px;border-radius:4px;background:rgba(74,95,243,0.08);font-size:12px;color:#4A5FF3;">辅助指标</span>
                          </div>
                          <div style="display:flex;align-items:center;gap:10px;">
                            <span style="font-size:12px;color:#8898aa;">当前: <span id="${valUnitCurrentId}" style="color:#4A5FF3;font-weight:600;"></span></span>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8898aa" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                            <span style="font-size:12px;color:#8898aa;">目标: <span id="${valUnitTargetId}" style="color:#4A5FF3;font-weight:600;"></span></span>
                          </div>
                          <div style="font-size:12px;color:#6b7280;margin-top:6px;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8898aa" stroke-width="2" style="margin-right:4px;vertical-align:middle;"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-5 3.6-9 8-9s8 4 8 9"/></svg>负责人：销售部 李明</div>
                        </div>
                        <span style="font-size:12px;color:#4A5FF3;text-decoration:underline;cursor:pointer;font-weight:500;" onclick="if(window.applyIndicator){window.applyIndicator('平均销售单价');}">应用</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="apply-a-section-2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
                  <div style="font-size:13px;font-weight:600;color:#4A5FF3;margin-bottom:12px;">新指标（待创建）</div>
                  <div style="display:flex;flex-direction:column;gap:10px;margin-bottom:14px;">
                    <div id="apply-a-new1-${replyId}" style="display:none;">
                      <div style="display:flex;align-items:center;gap:12px;padding:14px;border-radius:10px;background:#f8fafc;border:1px dashed #4A5FF3;">
                        <div style="flex:1;">
                          <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                            <span style="font-size:13px;font-weight:600;color:#1f2937;">产品调价覆盖率</span>
                            <span style="padding:3px 8px;border-radius:4px;background:rgba(74,95,243,0.08);font-size:12px;color:#4A5FF3;">新指标</span>
                          </div>
                          <div id="${descNew1Id}" style="font-size:12px;color:#5a6b7e;min-height:18px;"></div>
                          <div style="font-size:12px;color:#6b7280;margin-top:6px;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8898aa" stroke-width="2" style="margin-right:4px;vertical-align:middle;"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-5 3.6-9 8-9s8 4 8 9"/></svg>负责人：销售部 李明</div>
                        </div>
                        <span style="font-size:12px;color:#4A5FF3;text-decoration:underline;cursor:pointer;font-weight:500;" onclick="if(window.createIndicator){window.createIndicator('产品调价覆盖率');}">创建</span>
                      </div>
                    </div>
                    <div id="apply-a-new2-${replyId}" style="display:none;">
                      <div style="display:flex;align-items:center;gap:12px;padding:14px;border-radius:10px;background:#f8fafc;border:1px dashed #4A5FF3;">
                        <div style="flex:1;">
                          <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                            <span style="font-size:13px;font-weight:600;color:#1f2937;">成本传导率</span>
                            <span style="padding:3px 8px;border-radius:4px;background:rgba(74,95,243,0.08);font-size:12px;color:#4A5FF3;">新指标</span>
                          </div>
                          <div id="${descNew2Id}" style="font-size:12px;color:#5a6b7e;min-height:18px;"></div>
                          <div style="font-size:12px;color:#6b7280;margin-top:6px;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8898aa" stroke-width="2" style="margin-right:4px;vertical-align:middle;"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-5 3.6-9 8-9s8 4 8 9"/></svg>负责人：销售部 李明</div>
                        </div>
                        <span style="font-size:12px;color:#4A5FF3;text-decoration:underline;cursor:pointer;font-weight:500;" onclick="if(window.createIndicator){window.createIndicator('成本传导率');}">创建</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="apply-a-section-3-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
                  <div style="font-size:12px;color:#5a6b7e;line-height:1.6;margin-bottom:16px;">建议优先应用「<span style="color:#4A5FF3;font-weight:600;">毛利率</span>」和「<span style="color:#4A5FF3;font-weight:600;">产品调价覆盖率</span>」两个核心指标，这将直接反映产品调价策略的执行效果和成本传导进度。</div>
                  <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:center;">
                    <button style="padding:10px 22px;border-radius:12px;font-size:13px;font-weight:600;border:none;cursor:pointer;color:#fff;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);white-space:nowrap;box-shadow:0 2px 8px rgba(74,95,243,0.25);transition:all 0.2s;" onclick="if(window.applyRecommendedIndicators){window.applyRecommendedIndicators();}">应用推荐方案</button>
                    <span style="display:inline-flex;align-items:center;padding:5px 10px;border-radius:999px;background:#eef2ff;border:1px solid rgba(74,95,243,0.18);font-size:12px;color:#4A5FF3;cursor:pointer;transition:all 0.15s;" onclick="if(window.applyAllIndicators){window.applyAllIndicators();}">全部应用</span>
                    <span style="display:inline-flex;align-items:center;padding:5px 10px;border-radius:999px;background:#eef2ff;border:1px solid rgba(74,95,243,0.18);font-size:12px;color:#4A5FF3;cursor:pointer;transition:all 0.15s;" onclick="if(window.generateMissingIndicators){window.generateMissingIndicators();}">生成缺失指标</span>
                    <span style="display:inline-flex;align-items:center;padding:5px 10px;border-radius:999px;background:#eef2ff;border:1px solid rgba(74,95,243,0.18);font-size:12px;color:#4A5FF3;cursor:pointer;transition:all 0.15s;" onclick="if(window.saveSkillToLibrary){window.saveSkillToLibrary();}">沉淀skill</span>
                  </div>
                </div>
              </div>
            </div>
          `
          this.appendLocalMessage('assistant', cardHtml, true)
          setTimeout(() => {
            const el = this._findVisibleEl(`apply-a-${replyId}`)
            if (el) {
              el.style.display = 'block'
              requestAnimationFrame(() => {
                el.style.opacity = '1'
                el.style.transform = 'translateY(0)'
              })
            }
            this.scrollSmartChatToBottom()
            // 1. 流式输出描述文本
            this.typeWriterEffect(descTextId, introText, () => {
              // 2. 展示 section 1（现有指标）
              setTimeout(() => {
                this.revealSection(`apply-a-section-1-${replyId}`, 'block')
                this.scrollSmartChatToBottom()
                // 3. 展示毛利率卡片，流式输出值
                setTimeout(() => {
                  const gross = this._findVisibleEl(`apply-a-gross-${replyId}`)
                  if (gross) {
                    gross.style.display = 'block'
                  }
                  this.scrollSmartChatToBottom()
                  this.typeWriterEffect(valGrossCurrentId, '17.1%', () => {
                    this.typeWriterEffect(valGrossTargetId, '18.7%', () => {
                      // 4. 展示单位产品毛利卡片，流式输出值
                      setTimeout(() => {
                        const unit = this._findVisibleEl(`apply-a-unit-${replyId}`)
                        if (unit) {
                          unit.style.display = 'block'
                        }
                        this.scrollSmartChatToBottom()
                        this.typeWriterEffect(valUnitCurrentId, '¥2,380', () => {
                          this.typeWriterEffect(valUnitTargetId, '¥2,560', () => {
                            // 5. 展示 section 2（新指标）
                            setTimeout(() => {
                              this.revealSection(`apply-a-section-2-${replyId}`, 'block')
                              this.scrollSmartChatToBottom()
                              // 6. 展示新指标1，流式输出描述
                              setTimeout(() => {
                                const new1 = this._findVisibleEl(
                                  `apply-a-new1-${replyId}`
                                )
                                if (new1) {
                                  new1.style.display = 'block'
                                }
                                this.scrollSmartChatToBottom()
                                this.typeWriterEffect(
                                  descNew1Id,
                                  '已执行调价产品数量占比，目标覆盖主力产品线80%以上，追踪价格传导进度',
                                  () => {
                                    // 7. 展示新指标2，流式输出描述
                                    setTimeout(() => {
                                      const new2 = this._findVisibleEl(
                                        `apply-a-new2-${replyId}`
                                      )
                                      if (new2) {
                                        new2.style.display = 'block'
                                      }
                                      this.scrollSmartChatToBottom()
                                      this.typeWriterEffect(
                                        descNew2Id,
                                        '衡量BOM成本上涨通过调价传导给客户的比例，目标传导率≥70%，确保利润不受侵蚀',
                                        () => {
                                          // 8. 展示 section 3（操作按钮）
                                          setTimeout(() => {
                                            this.revealSection(
                                              `apply-a-section-3-${replyId}`,
                                              'block'
                                            )
                                            this.scrollSmartChatToBottom()
                                          }, 200)
                                        }
                                      )
                                    }, 300)
                                  }
                                )
                              }, 300)
                            }, 300)
                          })
                        })
                      }, 300)
                    })
                  })
                }, 300)
              }, 200)
            })
          }, 200)
        }, 1800)
      }, 800)
    },
    applyIndicator(name) {
      this.appendLocalMessage('user', `应用「${name}」指标`)
      const indicatorInfo = {
        毛利率: {
          current: '17.1%',
          target: '18.7%',
          kpi: '月度毛利率达标率≥95%',
          dept: '销售部',
          person: '李明'
        },
        产品调价覆盖率: {
          current: '52%',
          target: '80%',
          kpi: '主力产品调价覆盖率≥80%',
          dept: '销售部',
          person: '李明'
        },
        平均销售单价: {
          current: '¥2,380',
          target: '¥2,560',
          kpi: 'ASP提升率≥7.5%',
          dept: '销售部',
          person: '李明'
        }
      }
      const info = indicatorInfo[name] || {
        current: '-',
        target: '-',
        kpi: '待定义',
        dept: '待定',
        person: '待定'
      }
      setTimeout(() => {
        const cardHtml = `<div style='padding:14px;border-radius:10px;background:#fff;border:1px solid #e8ecf0;'>
          <div style='font-size:13px;font-weight:600;color:#1f2937;margin-bottom:10px;'>指标应用成功</div>
          <div style='font-size:12px;color:#5a6b7e;line-height:1.8;'>
            <p style='margin-bottom:8px;'>正在应用指标「<span style='color:#4A5FF3;font-weight:600;'>${name}</span>」，该指标从当前值 <span style='color:#DC2626;font-weight:600;'>${info.current}</span> 调整为目标值 <span style='color:#059669;font-weight:600;'>${info.target}</span>。</p>
            <p style='margin-bottom:8px;'>已生成KPI：<span style='color:#4A5FF3;font-weight:600;'>${info.kpi}</span></p>
            <p>KPI已下发给：<span style='color:#004baa;font-weight:600;'>${info.dept}-${info.person}</span></p>
          </div>
        </div>`
        this.appendLocalMessage('assistant', cardHtml, true)
      }, 500)
    },
    createIndicator(name) {
      this.appendLocalMessage('user', `创建「${name}」指标`)
      setTimeout(() => {
        const thinkingId = 'create-indicator-thinking-' + Date.now()
        const thinkingHtml = `
          <div id="${thinkingId}" style="margin-top:12px;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">
              <div style="width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#722ed1,#9254de);display:flex;align-items:center;justify-content:center;">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M12 2a10 10 0 1 0 10 10" stroke-linecap="round"/>
                  <path d="M12 6v6l4 2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span style="font-size:12px;color:#722ed1;font-weight:500;">深度思考中</span>
            </div>
            <div id="create-indicator-text-${thinkingId}" style="padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,rgba(114,46,209,0.04),rgba(146,84,222,0.04));border:1px solid rgba(114,46,209,0.12);">
              <div style="font-size:12px;color:#5a6b7e;line-height:1.8;">正在验证指标命名规范...</div>
            </div>
          </div>
        `
        this.appendLocalMessage('assistant', thinkingHtml, true)
        const createSteps = [
          '正在验证指标命名规范...',
          '检查指标名称唯一性...',
          '定义指标计算逻辑...',
          '配置指标数据来源...',
          '设置指标预警阈值...',
          '生成指标唯一标识...',
          '指标元数据保存完成...'
        ]
        let stepIndex = 0
        const createInterval = setInterval(() => {
          if (stepIndex < createSteps.length) {
            const textEl = this._findVisibleEl('create-indicator-text-' + thinkingId)
            if (textEl) {
              textEl.innerHTML = `<div style="font-size:12px;color:#5a6b7e;line-height:1.8;">${createSteps[stepIndex]}</div>`
            }
            stepIndex++
          } else {
            clearInterval(createInterval)
            setTimeout(() => {
              const thinkingCard = this._findVisibleEl(thinkingId)
              if (thinkingCard) {
                thinkingCard.style.opacity = '0'
                thinkingCard.style.transition = 'opacity 0.5s ease'
                setTimeout(() => {
                  thinkingCard.remove()
                }, 500)
              }
              const cardHtml = `<div style="padding:14px;border-radius:10px;background:#fff;border:1px solid #e8ecf0;">
                <div style="font-size:13px;font-weight:600;color:#1f2937;margin-bottom:10px;">指标创建成功</div>
                <div style="padding:12px;border-radius:8px;background:#f8fafc;">
                  <div style="font-size:12px;color:#5a6b7e;line-height:1.6;">
                    <p><strong style="color:#1f2937;">指标名称：</strong><span style="color:#722ed1;font-weight:600;">${name}</span></p>
                    <p><strong style="color:#1f2937;">指标ID：</strong>IND-${Date.now()
    .toString(36)
    .toUpperCase()}</p>
                    <p><strong style="color:#1f2937;">创建时间：</strong>${new Date().toLocaleString(
    'zh-CN'
  )}</p>
                    <p><strong style="color:#1f2937;">状态：</strong><span style="color:#389e0d;">已启用</span></p>
                    <p><strong style="color:#1f2937;">计算逻辑：</strong>根据业务规则自动计算</p>
                    <p><strong style="color:#1f2937;">预警阈值：</strong>已配置默认阈值</p>
                  </div>
                </div>
              </div>`
              this.appendLocalMessage('assistant', cardHtml, true)
            }, 800)
          }
        }, 800)
        this.smartAnalysisTimers.push(createInterval)
      }, 500)
    },
    generateMissingIndicators() {
      this.appendLocalMessage('user', '生成缺失指标，丰富指标库')
      setTimeout(() => {
        const thinkingId = 'thinking-indicator-' + Date.now()
        const indicatorSteps = [
          '正在分析历史对话记录...',
          '提取对话中的业务关键词：毛利率、PVMC、销量、成本、产品结构...',
          '识别关键数据指标：17.1%毛利率、-1.6%同比变化、6.2%订单下降...',
          '分析指标关联关系，构建指标体系...',
          '检测缺失指标：产品结构优化率、客户毛利贡献度...',
          '评估指标创建价值和可行性...',
          '生成完整的新指标建议列表...'
        ]
        const cardHtml = this.renderCeoThinkingCard(
          thinkingId,
          '分析历史对话输入输出...',
          '新指标分析',
          '正在分析对话内容，提取可创建的新指标...',
          indicatorSteps.length
        )
        this.appendLocalMessage('assistant', cardHtml, true)
        let stepIndex = 0
        const indicatorInterval = setInterval(() => {
          if (stepIndex < indicatorSteps.length) {
            this.updateCeoThinkingCard(thinkingId, indicatorSteps, stepIndex)

            stepIndex++
          } else {
            clearInterval(indicatorInterval)
            setTimeout(() => {
              this.removeThinkingCard(thinkingId)
              this.showNewIndicatorsResults()
            }, 800)
          }
        }, 900)
        this.smartAnalysisTimers.push(indicatorInterval)
      }, 500)
    },
    showNewIndicatorsResults() {
      const replyId = 'show-new-ind-' + Date.now()
      const indicators = [
        {
          name: '产品结构优化率',
          formula: '产品结构优化率 = (高毛利产品销售额 / 总销售额) × 100%',
          definition:
            '衡量高毛利产品在销售结构中的占比，反映产品结构优化效果。目标值建议设定为≥35%。'
        },
        {
          name: '客户毛利贡献度',
          formula: '客户毛利贡献度 = (客户贡献毛利 / 总毛利) × 100%',
          definition:
            '衡量单个客户对整体毛利的贡献程度，用于客户价值分层和重点客户识别。'
        },
        {
          name: '毛利敏感度指数',
          formula: '毛利敏感度指数 = (毛利变化率 / 价格变化率)',
          definition:
            '衡量毛利对价格变动的敏感程度，用于定价决策分析和利润预测。指数越高表示价格变动对毛利影响越大。'
        }
      ]
      const listHtml = indicators
        .map(
          (indicator, index) => `
        <div id="indicator-item-${index}" style="display:none;padding:14px;border-radius:10px;background:#f8fafc;border:1px dashed #4A5FF3;opacity:0;transform:translateX(-6px);transition:all .32s ease;">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <div id="indicator-check-${index}" style="width:20px;height:20px;border-radius:50%;border:2px dashed #4A5FF3;display:flex;align-items:center;justify-content:center;">
            </div>
            <span style="font-size:13px;font-weight:600;color:#1f2937;">${indicator.name}</span>
            <span style="padding:3px 8px;border-radius:4px;background:rgba(74,95,243,0.08);font-size:12px;color:#4A5FF3;">新指标</span>
          </div>
          <div style="padding:8px;border-radius:6px;background:#f0f5ff;margin-bottom:6px;border:1px solid rgba(74,95,243,0.1);">
            <div style="font-size:11px;color:#8898aa;margin-bottom:2px;">计算公式</div>
            <div style="font-size:12px;color:#4A5FF3;font-family:monospace;">${indicator.formula}</div>
          </div>
          <div style="font-size:12px;color:#5a6b7e;">${indicator.definition}</div>
        </div>
      `
        )
        .join('')
      const cardHtml = `<div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
        <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">创建新指标</div>
        <div id="${replyId}" style="font-size:12px;color:#5a6b7e;line-height:1.7;margin-bottom:14px;min-height:22px;"></div>
        <div style="display:flex;flex-direction:column;gap:12px;" id="create-indicator-list">
          ${listHtml}
        </div>
        <div id="create-progress-message" style="display:none;margin-top:12px;padding:12px;border-radius:8px;background:#f0f5ff;border:1px solid rgba(74,95,243,0.18);font-size:12px;color:#5a6b7e;text-align:center;">准备创建指标...</div>
        <div style="margin-top:12px;display:flex;gap:12px;align-items:center;">
          <button id="batch-create-btn" style="padding:10px 20px;border-radius:12px;font-size:13px;font-weight:600;border:2px solid #4A5FF3;cursor:pointer;color:#4A5FF3;background:#fff;white-space:nowrap;transition:all 0.2s;" onclick="if(window.startBatchCreateIndicators){window.startBatchCreateIndicators();}">开始创建指标</button>
          <span style="font-size:12px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="if(window.saveSkillToLibrary){window.saveSkillToLibrary();}">将方法论沉淀成skill</span>
        </div>
      </div>`
      this.appendLocalMessage('assistant', cardHtml, true)
      setTimeout(() => {
        this.typeWriterEffect(
          replyId,
          '基于对话内容分析，已识别出3个可创建的新指标',
          () => {
            setTimeout(() => {
              const item0 = this._findVisibleEl('indicator-item-0')
              if (item0) {
                item0.style.display = 'block'
                item0.style.opacity = '1'
                item0.style.transform = 'translateX(0)'
              }
            }, 300)
            setTimeout(() => {
              const item1 = this._findVisibleEl('indicator-item-1')
              if (item1) {
                item1.style.display = 'block'
                item1.style.opacity = '1'
                item1.style.transform = 'translateX(0)'
              }
            }, 700)
            setTimeout(() => {
              const item2 = this._findVisibleEl('indicator-item-2')
              if (item2) {
                item2.style.display = 'block'
                item2.style.opacity = '1'
                item2.style.transform = 'translateX(0)'
              }
              const progressMsg = this._findVisibleEl('create-progress-message')
              if (progressMsg) progressMsg.style.display = 'block'
            }, 1100)
          }
        )
      }, 200)
    },
    startBatchCreateIndicators() {
      const batchBtn = this._findVisibleEl('batch-create-btn')
      if (batchBtn) batchBtn.style.display = 'none'
      const indicators = [
        {
          name: '产品结构优化率',
          steps: [
            '正在定义指标名称...',
            '正在编写计算公式...',
            '正在设置阈值范围...',
            '正在关联业务场景...',
            '创建完成'
          ]
        },
        {
          name: '客户毛利贡献度',
          steps: [
            '正在定义指标名称...',
            '正在编写计算公式...',
            '正在设置阈值范围...',
            '正在关联业务场景...',
            '创建完成'
          ]
        },
        {
          name: '毛利敏感度指数',
          steps: [
            '正在定义指标名称...',
            '正在编写计算公式...',
            '正在设置阈值范围...',
            '正在关联业务场景...',
            '创建完成'
          ]
        }
      ]
      let currentIndex = 0
      let currentStep = 0
      const progressMsg = this._findVisibleEl('create-progress-message')
      const animateIndicator = () => {
        const item = this._findVisibleEl('indicator-item-' + currentIndex)
        const check = this._findVisibleEl('indicator-check-' + currentIndex)
        if (currentIndex < indicators.length) {
          if (currentStep === 0) {
            if (item) {
              item.style.transition = 'all 0.3s ease'
              item.style.borderStyle = 'solid'
              item.style.opacity = '0.7'
              item.style.transform = 'translateX(5px)'
            }
            if (check) {
              check.innerHTML =
                '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="3"><circle cx="12" cy="12" r="8" stroke-dasharray="50" stroke-dashoffset="50"><animate attributeName="stroke-dashoffset" from="50" to="0" dur="0.5s" fill="freeze"/></circle></svg>'
              check.style.borderStyle = 'dashed'
            }
          }
          if (currentStep < indicators[currentIndex].steps.length && progressMsg) {
            progressMsg.innerHTML = `正在创建「<span style="color:#4A5FF3;font-weight:600;">${indicators[currentIndex].name}</span>」: ${indicators[currentIndex].steps[currentStep]}`
          }
          currentStep++
          if (currentStep >= indicators[currentIndex].steps.length) {
            if (item) {
              item.style.opacity = '1'
              item.style.transform = 'translateX(0)'
              item.style.background = '#fff'
            }
            if (check) {
              check.innerHTML =
                '<svg width="12" height="12" viewBox="0 0 24 24" fill="#52c41a" stroke="#52c41a" stroke-width="3"><polyline points="20 6 9 17 4 12" stroke-linecap="round" stroke-linejoin="round"/></svg>'
              check.style.borderColor = '#52c41a'
              check.style.borderStyle = 'solid'
            }
            currentIndex++
            currentStep = 0
          }
        } else {
          if (progressMsg) {
            progressMsg.innerHTML =
              '<span style="color:#52c41a;">✓ 所有指标创建完成！已成功创建3个新指标，并存入企业指标字典。</span>'
          }
          return
        }
        setTimeout(animateIndicator, 400)
      }
      animateIndicator()
    },
    saveSkillToLibrary() {
      this.appendLocalMessage('user', '沉淀skill')
      setTimeout(() => {
        const thinkingSteps = [
          '正在解析「毛利率分析与优化方案」方法论...',
          '正在提取关键分析模块：PVMC模型、四象限方案、指标管理、缺失指标识别',
          '正在将方法论结构化为可复用的Skill模板...',
          '正在保存至企业Skill库...'
        ]
        const thinkingId = 'thinking-skill-' + Date.now()
        const thinkingHtml = this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '沉淀Skill',
          '正在将方法论沉淀为可复用的Skill...',
          thinkingSteps.length
        )
        this.appendLocalMessage('assistant', thinkingHtml, true)
        let stepIndex = 1
        const thinkTimer = setInterval(() => {
          if (stepIndex < thinkingSteps.length) {
            this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIndex)
            stepIndex++
          } else {
            clearInterval(thinkTimer)
            setTimeout(() => {
              this.removeThinkingCard(thinkingId)
              setTimeout(() => {
                const replyId = 'skill-result-' + Date.now()
                const resultHtml = `<div style="padding:14px;border-radius:10px;background:#fff;border:1px solid #e8ecf0;">
                  <div style="font-size:13px;font-weight:600;color:#1f2937;margin-bottom:10px;">Skill沉淀成功</div>
                  <div id="${replyId}" style="font-size:12px;color:#5a6b7e;line-height:1.8;min-height:22px;"></div>
                </div>`
                this.appendLocalMessage('assistant', resultHtml, true)
                setTimeout(() => {
                  this.smartTypeWriterEffect(
                    replyId,
                    '已将「毛利率分析与优化方案」方法论沉淀为可复用的Skill，包含以下核心模块：<br><br>• <span style="color:#4A5FF3;font-weight:600;">PVMC模型分析</span>：四维拆解毛利下降原因<br>• <span style="color:#4A5FF3;font-weight:600;">四象限提升方案</span>：生成可执行的毛利率提升方案<br>• <span style="color:#4A5FF3;font-weight:600;">指标组合管理</span>：应用和创建关键指标<br>• <span style="color:#4A5FF3;font-weight:600;">缺失指标识别</span>：从对话中提取新指标<br><br><span style="border-top:1px solid #e8ecf0;padding-top:10px;display:block;">该Skill已保存至企业Skill库，可在其他业务场景中复用。</span>'
                  )
                }, 200)
              }, 320)
            }, 500)
          }
        }, 800)
        this.smartAnalysisTimers.push(thinkTimer)
      }, 500)
    },
    applyPlanB() {
      this.appendLocalMessage('user', '应用产品结构优化方案')
      setTimeout(() => {
        const thinkingSteps = [
          '正在解析"产品结构优化"方案详情...',
          '方案策略：提升高毛利产品销售占比，优化产品组合结构',
          '正在评估对综合毛利率的影响：预计可提升+0.8%',
          '正在匹配执行负责人：产品部-王芳',
          '方案验证通过，正在生成执行确认...'
        ]
        const thinkingId = 'apply-plan-b-' + Date.now()
        this.appendLocalMessage(
          'assistant',
          this.renderCeoThinkingCard(
            thinkingId,
            thinkingSteps[0],
            '应用产品结构优化方案',
            '正在解析方案内容并匹配执行人...',
            thinkingSteps.length
          ),
          true
        )
        let stepIdx = 1
        const thinkTimer = setInterval(() => {
          if (stepIdx < thinkingSteps.length) {
            this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
            stepIdx++
          } else {
            clearInterval(thinkTimer)
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              const replyId = 'apply-b-' + Date.now()
              const textId = `apply-b-text-${replyId}`
              const cardHtml = `
                <div id="apply-b-${replyId}" style="opacity:0;transform:translateY(8px);transition:all .28s ease;">
                  <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
                    <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
                      <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#F59E0B,#FBBF24);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">M</div>
                      <div>
                        <div style="font-size:12px;font-weight:600;color:#1f2937;">营销数字人</div>
                        <div style="font-size:10px;color:#8c9bab;">刚刚</div>
                      </div>
                    </div>
                    <div id="${textId}" style="font-size:13px;color:#3d4f5f;line-height:1.7;min-height:22px;"></div>
                  </div>
                </div>
              `
              this.appendLocalMessage('assistant', cardHtml, true)
              setTimeout(() => {
                const el = this._findVisibleEl(`apply-b-${replyId}`)
                if (el) {
                  el.style.opacity = '1'
                  el.style.transform = 'translateY(0)'
                }
                this.typeWriterEffect(
                  textId,
                  '已生成产品结构优化方案：提升高毛利产品销售占比从38%至45%，建立分级销售激励机制，加强产品生命周期管理。预计可提升毛利+0.8%，方案已同步给「产品部-王芳」执行。'
                )
              }, 200)
            }, 500)
          }
        }, 1500)
        this.smartAnalysisTimers.push(thinkTimer)
      }, 400)
    },
    applyPlanC() {
      this.appendLocalMessage('user', '应用材料降本方案')
      setTimeout(() => {
        const thinkingSteps = [
          '正在解析"材料降本"方案详情...',
          '方案策略：与核心供应商签订锁价协议，开发备选供应商',
          '正在评估对原材料成本的影响：预计降低8%，提升毛利+0.6%',
          '正在匹配执行负责人：采购部-张丽',
          '方案验证通过，正在生成执行确认...'
        ]
        const thinkingId = 'apply-plan-c-' + Date.now()
        this.appendLocalMessage(
          'assistant',
          this.renderCeoThinkingCard(
            thinkingId,
            thinkingSteps[0],
            '应用材料降本方案',
            '正在解析方案内容并匹配执行人...',
            thinkingSteps.length
          ),
          true
        )
        let stepIdx = 1
        const thinkTimer = setInterval(() => {
          if (stepIdx < thinkingSteps.length) {
            this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
            stepIdx++
          } else {
            clearInterval(thinkTimer)
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              const replyId = 'apply-c-' + Date.now()
              const textId = `apply-c-text-${replyId}`
              const cardHtml = `
                <div id="apply-c-${replyId}" style="opacity:0;transform:translateY(8px);transition:all .28s ease;">
                  <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
                    <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
                      <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#3B82F6,#60A5FA);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">P</div>
                      <div>
                        <div style="font-size:12px;font-weight:600;color:#1f2937;">采购数字人</div>
                        <div style="font-size:10px;color:#8c9bab;">刚刚</div>
                      </div>
                    </div>
                    <div id="${textId}" style="font-size:13px;color:#3d4f5f;line-height:1.7;min-height:22px;"></div>
                  </div>
                </div>
              `
              this.appendLocalMessage('assistant', cardHtml, true)
              setTimeout(() => {
                const el = this._findVisibleEl(`apply-c-${replyId}`)
                if (el) {
                  el.style.opacity = '1'
                  el.style.transform = 'translateY(0)'
                }
                this.typeWriterEffect(
                  textId,
                  '已生成材料降本方案：与核心供应商签订3个月锁价协议，开发2-3家备选供应商引入竞争机制。预计可降低原材料成本8%，提升毛利+0.6%，方案已同步给「采购部-张丽」执行。'
                )
              }, 200)
            }, 500)
          }
        }, 1500)
        this.smartAnalysisTimers.push(thinkTimer)
      }, 400)
    },
    applyPlanD() {
      this.appendLocalMessage('user', '应用制造成本优化方案')
      setTimeout(() => {
        const thinkingSteps = [
          '正在解析"制造成本优化"方案详情...',
          '方案策略：优化生产排程提升产能利用率，工艺改进降低废品率',
          '正在评估对毛利率的影响：预计可提升+0.4%',
          '正在匹配执行负责人：生产部-刘强',
          '方案验证通过，正在生成执行确认...'
        ]
        const thinkingId = 'apply-plan-d-' + Date.now()
        this.appendLocalMessage(
          'assistant',
          this.renderCeoThinkingCard(
            thinkingId,
            thinkingSteps[0],
            '应用制造成本优化方案',
            '正在解析方案内容并匹配执行人...',
            thinkingSteps.length
          ),
          true
        )
        let stepIdx = 1
        const thinkTimer = setInterval(() => {
          if (stepIdx < thinkingSteps.length) {
            this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
            stepIdx++
          } else {
            clearInterval(thinkTimer)
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              const replyId = 'apply-d-' + Date.now()
              const textId = `apply-d-text-${replyId}`
              const cardHtml = `
                <div id="apply-d-${replyId}" style="opacity:0;transform:translateY(8px);transition:all .28s ease;">
                  <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
                    <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
                      <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#EF4444,#F87171);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">M</div>
                      <div>
                        <div style="font-size:12px;font-weight:600;color:#1f2937;">制造数字人</div>
                        <div style="font-size:10px;color:#8c9bab;">刚刚</div>
                      </div>
                    </div>
                    <div id="${textId}" style="font-size:13px;color:#3d4f5f;line-height:1.7;min-height:22px;"></div>
                  </div>
                </div>
              `
              this.appendLocalMessage('assistant', cardHtml, true)
              setTimeout(() => {
                const el = this._findVisibleEl(`apply-d-${replyId}`)
                if (el) {
                  el.style.opacity = '1'
                  el.style.transform = 'translateY(0)'
                }
                this.typeWriterEffect(
                  textId,
                  '已生成制造成本优化方案：优化生产排程提升产能利用率至75%+，工艺改进降低废品率至2.0%。预计可提升毛利+0.4%，方案已同步给「生产部-刘强」执行。'
                )
              }, 200)
            }, 500)
          }
        }, 1500)
        this.smartAnalysisTimers.push(thinkTimer)
      }, 400)
    },
    async runCoreMetricAnalysis(metricItem) {
      const analysisConfig = this.getCoreMetricAnalysisConfig(metricItem)
      const metricName = metricItem.name || '核心指标'
      this.addSmartFlowHistory(`分析${metricName}`)
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', `分析${metricName}`)
      ])
      const thinkingSteps = analysisConfig.simplifiedSteps || []
      const thinkingId = `core-metric-thinking-${Date.now()}`
      const thinkingIntervalMs = 700
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          analysisConfig.label + '核心指标分析',
          analysisConfig.summary,
          thinkingSteps.length
        ),
        true
      )
      let stepIndex = 1
      const thinkingInterval = setInterval(() => {
        if (stepIndex < thinkingSteps.length) {
          this.updateThinkingCard(thinkingId, thinkingSteps, stepIndex)
          stepIndex++
        } else {
          clearInterval(thinkingInterval)
          setTimeout(() => {
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderCoreMetricStreamCard(analysisConfig)
            }, 320)
          }, thinkingIntervalMs)
        }
      }, thinkingIntervalMs)
      this.smartAnalysisTimers.push(thinkingInterval)
    },
    runCoreMetricAgentAnalysis(config) {
      const agents = config.agents || []
      let agentIndex = 0
      const runNextAgent = () => {
        if (agentIndex < agents.length) {
          const agent = agents[agentIndex]
          this.renderCoreMetricAgentCard(agent, agentIndex + 1, () => {
            agentIndex++
            runNextAgent()
          })
        } else {
          setTimeout(() => {
            this.renderCoreMetricStreamCard(config)
          }, 500)
        }
      }
      runNextAgent()
    },
    renderCoreMetricAgentCard(agent, phase, onComplete) {
      const agentId = `agent-${Date.now()}-${phase}`
      const followUpToken = `core-metric-followup-${agentId}`
      this.followUpRegistry = this.followUpRegistry || {}
      this.followUpRegistry[followUpToken] = {
        title: `追问${agent.name}分析`,
        summary: `基于${agent.name}的分析内容，请继续深入说明。`,
        prompt: `基于刚才「${agent.name}」的分析内容，请继续展开关键原因、影响范围、潜在风险和下一步建议。`
      }
      const agentHtml = `
        <div data-ceo-card="shell" id="${agentId}" style="margin-top:2px;opacity:0;transform:translateY(8px);transition:all .28s ease;background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px 16px 14px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
          <div style="min-width:0;width:100%;box-sizing:border-box;">
            <div style="display:flex;align-items:center;gap:8px;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;">${
  agent.name
}</div>
              ${
  agent.roleLabel
    ? `<span style="font-size:10px;color:#8c9bab;">${agent.roleLabel}</span>`
    : ''
}
              <span style="font-size:10px;color:#8c9bab;margin-left:auto;">刚刚</span>
            </div>
            <div style="font-size:15px;font-weight:700;color:#1f2937;margin-top:12px;">${
  agent.title
}</div>
            <div style="width:100%;box-sizing:border-box;margin-top:8px;">
              <div id="${agentId}-content" style="font-size:13px;color:#475569;line-height:1.9;white-space:pre-line;min-height:44px;"></div>
            </div>
            <div id="${agentId}-followup" style="margin-top:12px;opacity:0;transform:translateY(8px);transition:all .28s ease;">
              <span style="font-size:11px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="window.triggerCeoFollowUp('${followUpToken}')">追问${
  agent.name
}</span>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', agentHtml, true)
      setTimeout(() => {
        const el = this._findVisibleEl(agentId)
        if (el) {
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'
        }
        const contentLength = agent.content.length
        const typeTime = contentLength * 35
        const followUpDelay = 0
        this.typeWriterEffect(`${agentId}-content`, agent.content)
        setTimeout(() => {
          const followUpEl = this._findVisibleEl(`${agentId}-followup`)
          if (followUpEl) {
            followUpEl.style.opacity = '1'
            followUpEl.style.transform = 'translateY(0)'
          }
        }, typeTime + 1000)
        setTimeout(() => {
          if (onComplete) onComplete()
        }, typeTime + 1000 + followUpDelay)
      }, 50)
    },
    createLocalMessage(type, content, richHtml = false, noCache = false) {
      return {
        id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        type,
        content,
        richHtml,
        timestamp: Date.now(),
        isHistory: false,
        _noCache: noCache
      }
    },
    /** 查找可见聊天容器内的 DOM 元素（侧栏和抽屉有不同 id，避免双实例 id 冲突） */
    _findVisibleEl(id) {
      const container = this._getVisibleChatContainer()
      if (container) {
        const el = container.querySelector('[id="' + id + '"]')
        if (el) return el
      }
      return document.getElementById(id)
    },
    /** 判断当前哪个聊天容器可见 */
    _getVisibleChatContainer() {
      const sidebar = document.getElementById('right-sidebar-chat')
      if (sidebar && sidebar.offsetParent !== null) return sidebar
      // #drawer-chat 在 el-drawer 关闭时（v-if="visible"）不存在于 DOM 中，存在即表示可见
      const drawer = document.getElementById('drawer-chat')
      if (drawer) return drawer
      return null
    },
    /**
     * 容器切换前，将当前可见容器的 richHtml 消息 DOM 状态同步回 Vuex store。
     * demo 流程通过 v-html 渲染初始 HTML 后，会直接操作 DOM（display、width 等），
     * 这些变更不会回写 store。切换容器时新实例从 store 重新渲染会丢失这些变更。
     * 此方法在切换前把可见容器的最新 DOM 序列化回写 store，保证新容器渲染正确。
     */
    syncRichHtmlDomToStore() {
      const container = this._getVisibleChatContainer()
      if (!container) return
      const items = container.querySelectorAll('.message-item[data-msg-id]')
      items.forEach((el) => {
        const msgId = el.getAttribute('data-msg-id')
        const richEl = el.querySelector('.rich-html-content')
        if (msgId && richEl) {
          this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
            id: msgId,
            content: richEl.innerHTML
          })
        }
      })
    },
    clearSmartAnalysisTimers() {
      this.smartAnalysisTimers.forEach((timer) => {
        clearTimeout(timer)
        clearInterval(timer)
      })
      this.smartAnalysisTimers = []
      this.smartFlowCardMessageId = null
      this.clearExistingThinkingCards()
    },
    /**
     * 清理手动插入的深度思考折叠条（非 Vue 管理的孤儿节点）
     */
    cleanupOrphanThinkingToggles() {
      document.querySelectorAll('[data-thinking-toggle="true"]').forEach((el) => {
        if (el.parentElement) el.parentElement.removeChild(el)
      })
      document.querySelectorAll('[id^="thinking-wrapper-"]').forEach((el) => {
        // 仅清理已被折叠隐藏的壳层，避免误删仍在进行中的思考卡
        if (el.style && el.style.maxHeight === '0px' && el.parentElement) {
          el.parentElement.removeChild(el)
        }
      })
    },
    /**
     * 切换数字人/会话时复位本地智能分析与流式残留状态
     */
    resetLocalThinkingState() {
      this.clearSmartAnalysisTimers()
      this.resetSmartFlowCard()
      this.cleanupOrphanThinkingToggles()
      this.$store.commit('cosmoClaw/SET_IS_STREAMING', false)
      this.$store.commit('cosmoClaw/SET_CURRENT_RUN_ID', null)
    },
    scheduleSmartAnalysis(fn, delay) {
      const timer = setTimeout(() => {
        this.smartAnalysisTimers = this.smartAnalysisTimers.filter(
          (item) => item !== timer
        )
        fn()
      }, delay)
      this.smartAnalysisTimers.push(timer)
    },
    setMessageContent(messageId, content) {
      // 使用 UPDATE_MESSAGE_CONTENT_BY_ID，mutation 内部会自动同步到 sessionCache
      this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
        id: messageId,
        content,
        richHtml: true
      })
      this.scrollSmartChatToBottom()
    },
    _persistCeoStrategyCard(content, staticMsgId, marker, sectionIds, typewriters) {
      if (staticMsgId) {
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content,
          richHtml: true
        })
        this._ensureCeoStrategyStyles()
        var self = this
        return new Promise(function (resolve) {
          self.$nextTick(function () {
            const sections = sectionIds || []
            sections.forEach((id) => {
              const section = self._findVisibleEl(id)
              if (!section) return
              section.style.display = 'block'
              section.style.opacity = '1'
              section.style.transform = 'translateY(0)'
              section.dataset.revealed = '1'
              const mask = section.querySelector('.ceo-strategy-mask')
              if (mask) {
                mask.style.display = 'none'
                mask.innerHTML = ''
              }
            })
            const texts = typewriters || []
            texts.forEach(({ id, text }) => {
              const el = self._findVisibleEl(id)
              if (el) el.textContent = text
            })
            resolve(true)
          })
        })
      }
      this.appendLocalMessage('assistant', content, true)
      this.persistMockMessage('assistant', marker)
      return Promise.resolve(false)
    },
    appendLocalMessage(type, content, richHtml = false, noCache = false) {
      // 依赖 DOM 操作的卡片不缓存：切换会话后恢复时 DOM 操作不会重新执行，
      // 导致卡片显示为空气泡或卡在初始 loading 状态
      if (!noCache && typeof content === 'string') {
        if (
          content.indexOf('thinking-track-') !== -1 ||
          content.indexOf('triggerCeoFollowUp') !== -1 ||
          (content.indexOf('display:none') !== -1 && type === 'assistant')
        ) {
          noCache = true
        }
      }
      const message = this.createLocalMessage(type, content, richHtml, noCache)
      this.$store.commit('cosmoClaw/ADD_MESSAGE', message)
      this.scrollSmartChatToBottom()
      return message
    },
    persistMockMessage(role, content, richHtml) {
      return this.$store.dispatch('cosmoClaw/storeMockMessage', {
        role,
        content,
        richHtml: !!richHtml
      })
    },
    appendSmartUserMessage(content) {
      if (!content) return
      this.appendLocalMessage('user', content)
    },
    resetSmartFlowCard() {
      this.smartFlowCardMessageId = null
      this.smartFlowHistory = []
    },
    getSmartFlowActionText(action, payload = {}) {
      const actionMap = {
        'pvmc-analysis': this.$t('workbench.actionPvmcAnalysis'),
        'pvmc-summary': this.$t('workbench.actionPvmcSummary'),
        'quadrant-plans': this.$t('workbench.actionQuadrantPlans'),
        'apply-plan': payload.plan
          ? this.$t('workbench.actionApplyPlan', { plan: payload.plan })
          : this.$t('workbench.actionApplyPlan', { plan: '' }),
        'apply-recommended-indicators': this.$t(
          'workbench.actionApplyRecommendedIndicators'
        ),
        'apply-all-indicators': this.$t('workbench.actionApplyAllIndicators'),
        'apply-single-indicator': payload.indicator
          ? this.$t('workbench.actionApplySingleIndicator', {
            indicator: payload.indicator
          })
          : this.$t('workbench.actionApplySingleIndicator', { indicator: '' }),
        'create-single-indicator': payload.indicator
          ? this.$t('workbench.actionCreateSingleIndicator', {
            indicator: payload.indicator
          })
          : this.$t('workbench.actionCreateSingleIndicator', { indicator: '' }),
        'create-missing-indicators': this.$t('workbench.actionCreateMissingIndicators'),
        'start-create-indicators': this.$t('workbench.actionStartCreateIndicators'),
        'save-method-skill': this.$t('workbench.actionSaveMethodSkill'),
        'view-pvmc-skill': this.$t('workbench.actionViewPvmcSkill'),
        'chain-performance-breakdown': '业绩解构',
        'chain-revenue-breakdown': '收入解构',
        'industry-competitiveness': '深度分析：行业解决方案竞争力不足'
      }
      return actionMap[action] || action || this.$t('workbench.actionSmartAnalysis')
    },
    addSmartFlowHistory(label) {
      if (!label) return
      this.smartFlowHistory = [...this.smartFlowHistory, label].slice(-8)
    },
    setSmartFlowCardContent(body, options = {}) {
      const isProgress = ['分析中', '处理中'].includes(options.status)
      const content = body || ''
      if (isProgress) {
        if (this.smartFlowCardMessageId) {
          this.setMessageContent(this.smartFlowCardMessageId, content)
          return
        }
        const message = this.appendLocalMessage('assistant', content, options.richHtml)
        this.smartFlowCardMessageId = message.id
        return
      }
      this.smartFlowCardMessageId = null
      if (content) this.appendLocalMessage('assistant', content)
    },
    runSmartFlowProgress({
      title,
      status,
      steps,
      interval = 650,
      finalBody,
      finalOptions = {}
    }) {
      this.clearSmartAnalysisTimers()
      const progressSteps =
        Array.isArray(steps) && steps.length ? steps : [this.$t('workbench.thinking')]
      this.setSmartFlowCardContent(
        this.getThinkingContent({
          title,
          summary: status,
          step: progressSteps[0],
          statusText: this.$t('workbench.statusDeepThinking')
        }),
        {
          title,
          status: this.$t('workbench.statusAnalyzing'),
          currentStep: progressSteps[0],
          richHtml: true
        }
      )
      progressSteps.slice(1).forEach((step, index) => {
        this.scheduleSmartAnalysis(() => {
          this.setSmartFlowCardContent(
            this.getThinkingContent({
              title,
              summary: status,
              step,
              statusText: this.$t('workbench.statusDeepThinking')
            }),
            {
              title,
              status: this.$t('workbench.statusAnalyzing'),
              currentStep: step,
              richHtml: true
            }
          )
        }, (index + 1) * interval)
      })
      this.scheduleSmartAnalysis(() => {
        this.setSmartFlowCardContent(finalBody, {
          title,
          status: finalOptions.status || '待操作',
          currentStep: finalOptions.currentStep || '分析结果已生成'
        })
        // 分析完成，退出 demo 模式
        this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
      }, progressSteps.length * interval + (finalOptions.delay || 400))
    },
    async ensureSmartFlowModelSession() {
      const socketState = this.$store.state.cosmoClaw.socketState
      if (socketState !== 'CONNECTED' && socketState !== 'CONNECTING') {
        this.$store.dispatch('cosmoClaw/connectShared', {
          accessUrl: getSharedWsUrl()
        })
      }
      let sessionKey = this.$store.state.cosmoClaw.currentSessionKey
      if (!sessionKey) {
        const preservedMessages = this.$store.state.cosmoClaw.messages
        sessionKey = await this.$store.dispatch('cosmoClaw/createNewSession', {
          agentName: this.digitalHumanList[0]
            ? this.digitalHumanList[0].agentName
            : 'ceo_shu_zi_ren'
        })
        if (preservedMessages.length) {
          this.$store.commit('cosmoClaw/SET_MESSAGES', preservedMessages)
        }
      }
      return sessionKey
    },
    async exitSmartFlowToModel(content, files) {
      this.clearSmartAnalysisTimers()
      this.addSmartFlowHistory(this.$t('workbench.analysisByModel'))
      this.smartFlowCardMessageId = null
      this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
      const sessionKey = await this.ensureSmartFlowModelSession()
      // 确保当前 agent 与 session 所属 agent 一致，否则 WS 响应不会同步到 state.messages
      const match = sessionKey && sessionKey.match(/^agent:([^:]+):/)
      const sessionAgentId = match ? match[1] : null
      const currentAgentId = this.$store.state.cosmoClaw.currentAgentId
      if (sessionAgentId && sessionAgentId !== currentAgentId) {
        await this.$store.dispatch('cosmoClaw/switchAgent', sessionAgentId)
      }
      const send = () => {
        this.$store.dispatch('cosmoClaw/sendMessage', {
          content,
          sessionKey,
          files
        })
      }
      if (this.$store.state.cosmoClaw.isHandshaked) {
        send()
      } else {
        setTimeout(send, 800)
      }
    }
  }
}
